import React from "react";
import "./SkipLink.scss";

export default function SkipLink() {
    return (
        <a className="skip-link" href="#main-content">
            Skip to main content
        </a>
    );
}
